"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.function.name");
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _axios = _interopRequireDefault(require("axios"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _store = _interopRequireDefault(require("@/store"));
var _elementUi = require("element-ui");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @constructor Service
 * @description common service class for axios ajax
 * @param {Object} axios options
 * @example Class YourService extends Service
 */
var Service = exports.default = /*#__PURE__*/function () {
  function Service(options) {
    (0, _classCallCheck2.default)(this, Service);
    options = options || {};
    var baseURL = process.env.VUE_APP_BASE_API_ADMIN;
    this.options = (0, _merge2.default)({
      baseURL: baseURL,
      timeout: 0,
      headers: {
        user: encodeURIComponent(localStorage.name),
        username: encodeURIComponent(localStorage.userNickname),
        group: encodeURIComponent(localStorage.group),
        siteId: localStorage.getItem("siteId")
        // siteId:1
      }
    }, options);
    this.http = this.createInstance(this.options);
    this.setRequestInterceptor();
    this.setResponseInterceptor();
  }

  /**
   * @description create axios instance
   * @param {Object} options axios instance options
   * @return {Object} axios instance
   */
  return (0, _createClass2.default)(Service, [{
    key: "createInstance",
    value: function createInstance(options) {
      var opt = Object.prototype.toString.call(options).slice(8, -1).toLowerCase() === "object" ? options : {};
      return _axios.default.create(opt);
    }

    /**
     * @description set request interceptor, only the last interceptor will be reserved
     * @param {Function} success request success callback handler
     * @param {Function} error request error callbach handler
     * @return {Object} xmlHttpRequest config / config error
     */
  }, {
    key: "setRequestInterceptor",
    value: function setRequestInterceptor(success, error) {
      // if request interceptor setted then eject it
      if (typeof this._requestInterceptor !== "undefined") {
        this.http.interceptors.request.eject(this._requestInterceptor);
      }
      this._requestInterceptor = this.http.interceptors.request.use(function (config) {
        // let requestConfig

        var token = localStorage.getItem("token");
        var Authorization = token;
        var requestConfig = _objectSpread(_objectSpread({}, config), {}, {
          headers: _objectSpread({}, config.headers || {})
        });
        if (config.url !== "/login" && Authorization) {
          requestConfig.headers["Authorization"] = "Bearer " + Authorization;
          requestConfig.headers["token"] = Authorization;
          requestConfig.headers["lang"] = localStorage.getItem("language");
        }
        if (typeof success === "function") {
          success(requestConfig);
        }
        return requestConfig;
      }, function (err) {
        if (typeof error === "function") {
          error(err);
        }
        return Promise.reject(err);
      });
    }

    /**
     * @description set response interceptor, only the last interceptor will be reserved
     * @param {Function} success response success callback handler
     * @param {Function} error response error callbach handler
     * @return {Object} xmlHttpRequest response / xmlHttpRequest error
     */
  }, {
    key: "setResponseInterceptor",
    value: function setResponseInterceptor(success, error) {
      var _this = this;
      // if response interceptor setted then eject it
      if (typeof this._responseInterceptor !== "undefined") {
        this.http.interceptors.response.eject(this._responseInterceptor);
      }
      this._responseInterceptor = this.http.interceptors.response.use(function (response) {
        if ([406].includes(response.data.code)) {
          var lang = localStorage.getItem("language") || "zh";
          _elementUi.Message.error(lang == "zh" ? "登录超时" : lang == "en" ? "Login timeout" : "Hết thời gian đăng nhập");
          _store.default.dispatch("LogOut").then(function () {
            location.reload();
          });
        }
        if (typeof success === "function") {
          return success(response.data);
        } else if (Number(response.status) !== 200) {
          // const message =
          //   response && response.message ? response.message : '接口请求报错'
          // Message.error(message)
        } else if (Number(response.status) === 200) {
          return response.data;
        }
        return response.data;
      }, function (err) {
        // console.log(err.response)
        if (err.response.status === 406) {
          if (typeof err === "function") {
            error(err);
          } else {
            _elementUi.Message.error(_this.$t("requestTimeOutPleaseLogin"));
            _store.default.dispatch("LogOut").then(function () {
              location.reload();
            });
          }
        }
        return Promise.reject(err);
      });
    }
  }]);
}();